import React from 'react'
import { makeStyles } from '@material-ui/core/styles'
import { connect } from 'react-redux'

import Stepper from '@material-ui/core/Stepper'
import Step from '@material-ui/core/Step'
import StepLabel from '@material-ui/core/StepLabel'
import Button from '@material-ui/core/Button'

import Link from '@material-ui/core/Link'
import Typography from '@material-ui/core/Typography'

import Dialog from '@material-ui/core/Dialog'
import DialogActions from '@material-ui/core/DialogActions'
import DialogContent from '@material-ui/core/DialogContent'
import DialogContentText from '@material-ui/core/DialogContentText'
import DialogTitle from '@material-ui/core/DialogTitle'

import { StepOne, StepTwo, StepThree } from './Index'

import { uploadRequest } from '../../actions'

import CircularProgress from '@material-ui/core/CircularProgress'

const useStyles = makeStyles((theme) => ({
  appBar: {
    position: 'relative'
  },
  layout: {
    width: 'auto',
    marginTop: theme.spacing(5),

    [theme.breakpoints.up(1000 + theme.spacing(2) * 2)]: {
      width: 1000,
      marginLeft: 'auto',
      marginRight: 'auto'
    }
  },
  paper: {
    marginBottom: theme.spacing(3),
    padding: theme.spacing(2),
    [theme.breakpoints.up(1000 + theme.spacing(3) * 2)]: {
      marginTop: theme.spacing(6),
      marginBottom: theme.spacing(6),
      padding: theme.spacing(3)
    }
  },
  stepper: {
    padding: theme.spacing(3, 0, 5)
  },
  buttons: {
    display: 'flex',
    justifyContent: 'flex-end'
  },
  button: {
    marginTop: theme.spacing(3),
    marginLeft: theme.spacing(1)
  }
}))

const steps = ['User Information', 'Final Review', 'Submit and Status']

function getStepContent(step) {
  switch (step) {
    case 0:
      return <StepOne />
    case 1:
      return <StepTwo />
    case 2:
      return <StepThree />
    default:
      throw new Error('Unknown step')
  }
}

const CreateUsersHome = (props) => {
  const { data } = props

  const classes = useStyles()
  const [activeStep, setActiveStep] = React.useState(0)

  const [open, setOpen] = React.useState(false)
  const [dialogTitle, setDialogTitle] = React.useState('')
  const [dialogText, setDialogText] = React.useState('')

  const { csvFile, onUpload } = props

  const handleClose = () => {
    setOpen(false)
  }

  const handleNext = () => {
    if (activeStep == 1) {
      setActiveStep(activeStep + 1)
    }

    if (activeStep == 0) {
      console.log(data)

      let userFormDataErrors = data.userFormData.filter(
        (users) =>
          users.emailError !== '' ||
          users.firstNameError !== '' ||
          users.lastNameError !== '' ||
          users.psIDError !== ''
      )

      let isEmpty = data.csvData.filter(
        (users) =>
          users[0] === '' ||
          users[2] === '' ||
          users[3] === '' ||
          users[4] === ''
      )

      console.log(userFormDataErrors, 'userFormDataErrors')
      console.log(isEmpty, 'isEmpty')

      if (isEmpty.length !== 0) {
        setDialogTitle('Warning!!')
        setDialogText('Please insert user information.')

        setOpen(true)
        return false
      }

      if (userFormDataErrors.length !== 0) {
        setDialogTitle('Warning!!')
        setDialogText('Please fix the errors before proceed next.')
        setOpen(true)
        return false
      }

      if (isEmpty.length === 0 && userFormDataErrors.length === 0) {
        setActiveStep(activeStep + 1)
      }
    }
  }

  const handleBack = () => {
    let progreess = activeStep - 1
    setActiveStep(progreess)
  }

  return (
    <React.Fragment>
      <Typography component='h1' variant='h5' align='center'>
        {' '}
        Create Users{' '}
      </Typography>

      <Stepper activeStep={activeStep} className={classes.stepper}>
        {steps.map((label) => (
          <Step key={label}>
            <StepLabel>{label}</StepLabel>
          </Step>
        ))}
      </Stepper>
      <React.Fragment>
        {activeStep === steps.length ? (
          <div> final </div>
        ) : (
          <React.Fragment>
            {getStepContent(activeStep)}
            <div className={classes.buttons}>
              {activeStep !== 0 && activeStep !== 2 && (
                <Button onClick={handleBack} className={classes.button}>
                  Back
                </Button>
              )}

              {activeStep !== 2 ? (
                <Button
                  variant='contained'
                  color='primary'
                  onClick={handleNext}
                  className={classes.button}
                  disabled={activeStep == 2 ? true : false}
                >
                  {activeStep == 2 ? '' : ''}

                  {activeStep === 1 ? 'Submit Data to Canvas' : ''}

                  {activeStep === 0 ? 'Next' : ''}
                </Button>
              ) : null}
            </div>
          </React.Fragment>
        )}
      </React.Fragment>

      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby='alert-dialog-title'
        aria-describedby='alert-dialog-description'
      >
        <DialogTitle id='alert-dialog-title'>{dialogTitle}</DialogTitle>
        <DialogContent>
          <DialogContentText id='alert-dialog-description'>
            {' '}
            {dialogText}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color='primary' autoFocus>
            Ok
          </Button>
        </DialogActions>
      </Dialog>
    </React.Fragment>
  )
}

function mapStateToProps(state) {
  return {
    data: state.CreateUsers
  }
}

const mapDispatchToProps = (dispatch) => ({
  onUpload: (file) => {
    dispatch(uploadRequest(file))
  }
})

export default connect(mapStateToProps, mapDispatchToProps)(CreateUsersHome)
